/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Cron_HintInputs */

const cs_field_cron_hint = /** @type {(inputs: Field_Cron_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardní 5-polí cron, např. 0 9 * * 1 = pondělí 9:00`)
};

const en_field_cron_hint = /** @type {(inputs: Field_Cron_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard 5-field cron, e.g. 0 9 * * 1 for Mondays at 9:00`)
};

/**
* | output |
* | --- |
* | "Standard 5-field cron, e.g. 0 9 * * 1 for Mondays at 9:00" |
*
* @param {Field_Cron_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_cron_hint = /** @type {((inputs?: Field_Cron_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Cron_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_cron_hint(inputs)
	return cs_field_cron_hint(inputs)
});